<template>
  <v-theme-provider dark>
    <base-section id="home-Head" class="blue-grey darken-3" space="20">
      <v-container>
        <v-row justify="center">
          <v-col cols="10">
            <h1>HOME</h1>

            <!--<base-body space="0">
              <span class="white--text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua
              </span>
            </base-body>-->
          </v-col>

          <v-col cols="12" md="2"> </v-col>
        </v-row>
      </v-container>
    </base-section>
  </v-theme-provider>
</template>

<script>
export default {
  name: "SectionContactUs",
};
</script>
<style scoped>
h1 {
  color: white;
}
</style>
